<template>
    <div class="container">
      <div class="head">
        <img src="@/assets/back1.png" style="margin: 10px" alt="返回" width="21" height="21" @click="go">
        <div style="margin-left: 30%">会员权益</div>
      </div>
      <div class="rechargeimg" :style="rechargeimg"  style="height: 170px; width: 95%;">
        <div class="message">
          <img :src="user.avatar" style="border-radius: 50%;" width="72" height="72"/>
          <div class="allname">
            <div class="name">{{user.name}}</div>
            <div class="chengyuan">
              <img src="@/assets/crown.png" width="14" height="14" style="margin-left: 8%;position: relative;top: 1px;"/>
              <span>成员</span>
            </div>
          </div>
        </div>
        <div class="dredge">
          <div class="dredgeprice" v-if="user.isvip == 0" @click="toVipPageView">开通会员</div>
          <div class="dredgeprice" v-if="user.isvip == 1" @click="toAttPageView">成为VIP创客</div>
          <div class="dredgeprice" v-if="user.isvip == 2">你已是VIP创客</div>
          <div class="dredgeHint"></div>
        </div>
        <div class="equity"  v-if="user.isvip == 0">开通会员VIP立享以下 <span style="font-size:18px;"> 12 </span> 大权益</div>
      </div>

      <div class="user-tools">
        <div style="height: 10px;"></div>
        <!--<div class="tools-header">-->
          <!--<div class="title">常用功能</div>-->
        <!--</div>-->
        <div class="tools-main">
          <div class="tools-item" v-for="(item,index) in commonList01" v-if="index<4" :key="index" @click="onNavigate(item)">
            <div class="icon"  style="background:rgba(80,69,65,1);border-radius:15px;">
              <img :src="item.icon" :alt="item.name" width="24" height="24">
            </div>
            <span class="name">{{item.name}}</span>
          </div>
        </div>
        <div class="tools-main">
          <div class="tools-item" v-for="(item,index) in commonList02" v-if="index<4" :key="index" @click="onNavigate(item)">
            <div class="icon"  style="background:rgba(80,69,65,1);border-radius:15px;">
              <img :src="item.icon" :alt="item.name" width="24" height="24">
            </div>
            <span class="name">{{item.name}}</span>
          </div>
        </div>
        <div class="tools-main">
          <div class="tools-item" v-for="(item,index) in commonList03" v-if="index<4" :key="index" @click="onNavigate(item)">
            <div class="icon"  style="background:rgba(80,69,65,1);border-radius:15px;">
              <img :src="item.icon" :alt="item.name" width="24" height="24">
            </div>
            <span class="name">{{item.name}}</span>
          </div>
        </div>
      </div>

      <div class="vipexplain">
        <img src="@/assets/crown.png" height="31" width="31"/>
        <div style="margin-left: 12px;margin-top: 8px">会员说明</div>
      </div>
      <div class="notify">
        <div>1.开通会员所缴纳的金额会以返利形式返利到您的账户中,可在商城中购物使用。</div>
        <div>2.新开通会员等级均为一级,等级根据交易量和交易金额进行升级。</div>
        <div>3.开通会员之后方可邀请好友,好友在商城消费的同时,你得返利。</div>
        <div>4.开通会员之后收益可提现，所获得的返利扣除相应的增值税。</div>
      </div>

    </div>
</template>

<script>
import { querySysIconInfoList, querySysVipSettingList,vipBuyBalance } from '@/api/vip/index'
import { getSysMakerSwitch } from '@/api/mine/maker.js'
import { getCurtUser } from '@/api/login/index.js'
export default {
  name: 'Index',
  data() {
    return {
      rechargeimg: {
        backgroundImage: 'url(' + require('@/assets/vip.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
        mozBackgroundSize: '100% 100%'
      },
      user : {
        avatar: ''
      },
      makerSwitch : {},
      commonList: [],
      commonList01: [
        {
          icon: require('@/assets/interests01.png'),
          name: '购物省钱',
          style: 'background:rgba(80,69,65,1);border-radius:15px;',
          url: '/mine/vip/commodity'
        },
        {
          icon: require('@/assets/interests02.png'),
          name: '专享低价',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        },
        {
          icon: require('@/assets/interests03.png'),
          name: '大牌折扣',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        },
        {
          icon: require('@/assets/interests04.png'),
          name: '分享挣钱',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        }
      ],
      commonList02: [
        {
          icon: require('@/assets/interests05.png'),
          name: '智能后台',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        },
        {
          icon: require('@/assets/interests06.png'),
          name: '优惠券',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        },
        {
          icon: require('@/assets/interests07.png'),
          name: '售后无忧',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        },
        {
          icon: require('@/assets/interests08.png'),
          name: '产品折扣',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        }
      ],
      commonList03: [
        {
          icon: require('@/assets/interests09.png'),
          name: '礼品赠送',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        },
        {
          icon: require('@/assets/interests10.png'),
          name: '佣金返利',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        },
        {
          icon: require('@/assets/interests11.png'),
          name: '推荐赚钱',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        },
        {
          icon: require('@/assets/interests12.png'),
          name: '零元创业',
          style: 'background:rgba(80,69,65,1);border-radius:15px;'
        }
      ]
    }
  },
  created() {
    this.getUser()
    this.getSysMakerSwitch()

  },
  methods: {
    _vipBuyBalance(type) {
      //用户信息
      var user = localStorage.getItem("userInfo")
      if (!user){
        this.$router.push({path: '/login'})
        return;
      }
      user = JSON.parse(user)

      let params = {
        type: type,
        payType: 1,
        uid: user.id,
        money: 0
      }
      vipBuyBalance(params).then((res) => {
        if (res.success) {
          this.$toast.success(res.msg);
          this.getUser()
        } else {
          this.$toast.fail(res.msg);
        }
      })
    },
    toVipPageView(){
      if (this.makerSwitch.isVip){
        this.$router.push({path:'/mine/vip/openVip'})
      }else{
        this._vipBuyBalance(0);
      }
    },
    toAttPageView(){
      if (this.makerSwitch.status){
        this.$router.push({path:'/mine/vip/attestation'})
      }else{
        this._vipBuyBalance(1);
      }
    },
    getUser(){
      var user = localStorage.getItem('userInfo')
      if (!user){
        this.$router.push({path: '/login'})
        return;
      }
      user = JSON.parse(user)
      getCurtUser({id: user.id}).then(res => {
        if (res.success) {
          this.user = res.data
        }
      })
    },
    // 跳转
    onNavigate(item) {
      this.$router.push({
        path: item.url
      })
    },
    openVIP (code) {
      this.user.isvip = code
      updateShopUser(this.user).then(res => {
        if (res.success) {
          this.$toast.success("开通成功")
          localStorage.setItem("userInfo",JSON.stringify(this.user))
        }
      })
    },
    go() {
      this.$router.go(-1)
    },
    getSysMakerSwitch() {
      getSysMakerSwitch(1).then((res) => {
        if (res.success){
          this.makerSwitch = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    padding-top: 0px;
    .head{
      background-color: #42404D;
      color: #ffffff;
      height:141px;
      line-height: 44px;
      opacity:1;
      display: flex;
      border-bottom-left-radius:40px;
      border-bottom-right-radius:50px;
    }
    .rechargeimg{
      margin-left: 2%;
      margin-top: -80px;
      .message{
        display: flex;
        margin: 12px;
        padding-top: 12px;
        padding-bottom: 12px;
        border-bottom: 1px dashed #E5AB96;
        .allname{
          padding: 12px;
          .name{
            font-size:16px;
            font-family:PingFang SC;
            font-weight:bold;
            line-height:22px;
            color:rgba(51,51,51,1);
            opacity:1;
          }
          .chengyuan{
            width:50px;
            height:20px;
            background:rgba(250,242,234,1);
            opacity:1;
            border-radius:23px;
            font-size:12px;
            font-family:PingFang SC;
            font-weight:bold;
            line-height:17px;
            color:rgba(245,193,100,1);
            margin-top: 6px;
          }
        }
      }
      .dredge{
        display: flex;
        .dredgeprice{
          width:135px;
          height:30px;
          background:rgba(145,76,49,1);
          opacity:1;
          border-radius:23px;
          font-size:14px;
          font-family:PingFang SC;
          font-weight:bold;
          line-height:30px;
          text-align: center;
          margin-left: 12px;
          color:rgba(251,221,72,1);
        }
        .dredgeHint{
          font-size:12px;
          font-family:PingFang SC;
          font-weight:bold;
          line-height:17px;
          margin-left: 12px;
          margin-top: 5px;
          color:rgba(145,76,49,1);
          opacity:1;
        }
      }
      .equity{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:bold;
        line-height:20px;
        color:rgba(145,76,49,1);
        opacity:1;
        margin-left: 12px;
        margin-top: 4px;
      }
    }

    .user-tools {
      height:350px;
      background:#63564D;
      margin-top: 12px;
      margin-left: 12px;
      margin-right: 12px;
      border-radius: 4px;
      .tools-header{
        height:22px;
        font-weight:bold;
        border-left: 4px solid #ffffff;
        padding-left: 8px;
        font-size:18px;
        line-height:25px;
        color:rgba(255,255,255,1);
        opacity:1;
        margin-left: 12px;
        margin-top: 12px;
      }
      .tools-main{
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        .tools-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 20px;
          .icon {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 46px;
            height: 46px;
            background: linear-gradient(201deg, rgba(255, 144, 105, 1) 0%, rgba(243, 8, 69, 1) 100%);
            border-radius: 50%;
          }
          .name {
            height: 20px;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            margin-top: 10px;
            color:#ffffff;
          }
        }
      }
    }

    .vipexplain{
      display: flex;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:bold;
      line-height:22px;
      color:rgba(51,51,51,1);
      opacity:1;
      margin-left: 12px;
      margin-top: 12px;
    }
    .notify{
      font-size:14px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:27px;
      color:rgba(102,102,102,1);
      opacity:1;
      margin-left: 15%;
      margin-top: 8px;
      margin-right: 12px;
      margin-bottom: 80px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/vip/index.vue